import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CreditCard } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

// Calm, non-alarmist banner shown when the subscription is past_due (a payment needs attention).
// Opens the Stripe Customer Portal so the member can update their card. Hides once active again.
export default function PastDueBanner() {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const location = useLocation();

  const refresh = () => api.get("/household/capacity").then((r) => setInfo(r.data)).catch(() => setInfo(null));
  useEffect(() => { refresh(); }, [location.pathname]);
  useEffect(() => {
    const onUpdate = () => refresh();
    window.addEventListener("subscription-updated", onUpdate);
    return () => window.removeEventListener("subscription-updated", onUpdate);
  }, []);

  const openPortal = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/billing/portal", { origin: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error("Could not open the billing portal. Please try again.");
      setBusy(false);
    }
  };

  if (info?.billing_state !== "past_due" || !info?.is_admin) return null;

  return (
    <div data-testid="past-due-banner"
      className="border-b border-[#FED7AA] bg-[#FFF7ED] px-4 py-2.5 sm:px-8">
      <div className="mx-auto flex max-w-5xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="flex items-start gap-2 text-sm leading-relaxed text-[#3f4a48]">
          <CreditCard className="mt-0.5 h-4 w-4 shrink-0 text-[#C2630E]" strokeWidth={1.7} />
          <span>
            <span className="font-medium text-[#2D3436]">Your last payment needs attention.</span>{" "}
            We weren't able to take your most recent payment. Update your payment details to keep your subscription running smoothly.
          </span>
        </p>
        <button data-testid="past-due-update-payment-btn" onClick={openPortal} disabled={busy}
          className="shrink-0 self-start rounded-lg bg-[#C2630E] px-4 py-1.5 text-sm font-medium text-white transition-transform hover:-translate-y-0.5 disabled:opacity-60 sm:self-auto">
          Update payment method
        </button>
      </div>
    </div>
  );
}
